export default __webpack_public_path__ + "static/media/DF2BF201-DCDF-44D5-BE83-17FCACE528E1_1_105_c.39ca8066.jpeg";